import {
  Component,
  Output,
  EventEmitter,
  Input,
  ChangeDetectionStrategy
} from '@angular/core';

import { ClientUser, ClientUserStatuses } from '@zerops/models/client-user';

@Component({
  selector: 'z-client-user-select',
  templateUrl: './client-user-select.container.html',
  styleUrls: [ './client-user-select.container.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ClientUserSelectContainer {

  clientUserStatuses = ClientUserStatuses;

  @Output()
  selected = new EventEmitter<ClientUser>();


  #data: ClientUser[];
  @Input()
  set data(v: ClientUser[]) {
    if (v) {
      this.#data = v.sort((a, b) => a.client.accountName.localeCompare(b.client.accountName))
    } else {
      this.#data = v;
    }
  };
  get data() {
    return this.#data;
  }
}
